<div class="page">
  <div class="header">
    <button mat-icon-button (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h1>Información del paciente</h1>
      <p>{{ paciente.nombre }} {{ paciente.apellido }} {{ paciente.segundoApellido }}</p>
    </div>
  </div>

  <mat-tab-group class="tabs" animationDuration="200ms">
    <!-- ============================== -->
    <!-- TAB 1: DATOS PERSONALES        -->
    <!-- ============================== -->
    <mat-tab label="Datos personales">
      <div class="tab-content">
        <section>
          <h3>Información general</h3>
          <div class="grid-info">
            <div class="dato">
              <span>Nombre completo</span>
              <strong
                >{{ paciente.nombre }} {{ paciente.apellido }}
                {{ paciente.segundoApellido }}</strong
              >
            </div>
            <div class="dato">
              <span>Edad</span>
              <strong>{{ obtenerEdad() }}</strong>
            </div>
            <div class="dato">
              <span>Fecha de nacimiento</span>
              <strong>{{ paciente.fechaNacimiento | date: 'dd/MM/yyyy' }}</strong>
            </div>
            <div class="dato">
              <span>Género</span>

              @if (paciente.genero === 'masculino') {
                <strong>Masculino</strong>
              }
              @if (paciente.genero === 'femenino') {
                <strong>Femenino</strong>
              }
            </div>
            <div class="dato">
              <span>Tipo de sangre</span>
              <strong>{{ paciente.tipoSangre }}</strong>
            </div>
          </div>
        </section>

        <section>
          <h3>Contacto</h3>
          <div class="grid-info">
            <div class="dato">
              <span>Dirección</span>
              <strong>{{ paciente.direccion || 'No registrada' }}</strong>
            </div>

            <div class="dato">
              <span>Municipio</span>
              <strong>{{ municipioNombre }}</strong>
            </div>

            <div class="dato">
              <span>Barrio o colonia</span>
              <strong>{{ barrioNombre }}</strong>
            </div>

            <div class="dato">
              <span>Teléfono</span>
              <strong>{{ paciente.telefono || 'No registrado' }}</strong>
            </div>
            <div class="dato">
              <span>Correo</span>
              <strong>{{ paciente.correo || 'No registrado' }}</strong>
            </div>
          </div>
        </section>

        <section>
          <h3>Contacto de emergencia</h3>
          <div class="grid-info">
            <div class="dato">
              <span>Nombre</span>
              <strong>{{ paciente.nombreContactoEmergencia || 'No registrado' }}</strong>
            </div>
            <div class="dato">
              <span>Parentesco</span>
              <strong>{{ paciente.parentescoContactoEmergencia || 'No registrado' }}</strong>
            </div>
            <div class="dato">
              <span>Teléfono</span>
              <strong>{{ paciente.telefonoContactoEmergencia || 'No registrado' }}</strong>
            </div>
            <div class="dato">
              <span>Dirección</span>
              <strong>{{ paciente.direccionContactoEmergencia || 'No registrada' }}</strong>
            </div>
          </div>
        </section>

        <section>
          <h3>Historia clínica</h3>

          @if (paciente.expediente) {
            <div class="grid-info">
              <div class="dato">
                <span>Alergias</span
                ><strong>{{ paciente.expediente.alergias || 'Ninguna' }}</strong>
              </div>
              <div class="dato">
                <span>Diabetes</span><strong>{{ paciente.expediente.diabetes || 'No' }}</strong>
              </div>
              <div class="dato">
                <span>Hipertensión</span
                ><strong>{{ paciente.expediente.hipertension || 'No' }}</strong>
              </div>
              <div class="dato">
                <span>Asma</span><strong>{{ paciente.expediente.asma || 'No' }}</strong>
              </div>
              <div class="dato">
                <span>Cirugías previas</span
                ><strong>{{ paciente.expediente.cirugiasPrevias || 'Ninguna' }}</strong>
              </div>
              <div class="dato">
                <span>Enfermedades concomitantes</span
                ><strong>{{ paciente.expediente.enfermedadesConcomitantes || 'Ninguna' }}</strong>
              </div>
            </div>
          } @else {
            <p class="sin-datos">Sin información registrada.</p>
          }
        </section>
      </div>
    </mat-tab>

    <!-- ============================== -->
    <!-- TAB 2: RESUMEN DE RECETAS       -->
    <!-- ============================== -->
    <!-- <mat-tab label="Resumen de recetas">
      <div class="tab-content">
        @if (cargandoRecetas) {
          <p class="sin-datos">Cargando información...</p>
        } @else if (recetas.length === 0) {
          <p class="sin-datos">Este paciente no tiene recetas registradas.</p>
        } @else {
          @for (receta of recetas; track receta.id) {
            <div class="receta-card">
              <div class="receta-header">
                <mat-icon>event_note</mat-icon>
                <strong>{{ receta.fecha | date: 'dd/MM/yyyy HH:mm' }}</strong>
              </div>

              <div class="receta-body">
                <div class="bloque">
                  <span class="etiqueta">Diagnóstico</span>
                  <p>{{ receta.diagnostico }}</p>
                </div>

                <div class="bloque">
                  <span class="etiqueta">Indicaciones</span>
                  <p class="pre">{{ receta.indicaciones }}</p>
                </div>

                @if (receta.medicamentos.length > 0) {
                  <div class="bloque">
                    <span class="etiqueta">Medicamentos</span>
                    <ul>
                      @for (med of receta.medicamentos; track med.nombre) {
                        <li>{{ med.nombre }} — {{ med.dosis }}, {{ med.frecuencia }}</li>
                      }
                    </ul>
                  </div>
                }

                @if (receta.estudios.length > 0) {
                  <div class="bloque">
                    <span class="etiqueta">Estudios solicitados</span>
                    <ul>
                      @for (est of receta.estudios; track est.nombre) {
                        <li>
                          <strong>{{ est.nombre }}</strong>
                          @if (est.resultado) {
                            — {{ est.resultado }}
                          } @else {
                            <em>(sin resultado registrado)</em>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    </mat-tab> -->
  </mat-tab-group>
</div>
